import { BrowserRouter } from "react-router-dom";
import { Provider } from 'react-redux';
import React from 'react';
import ReactDOM from 'react-dom';

import "./object.fromEntries.polyfill.js";
import 'intl-pluralrules';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import './index.scss';

import App from './components/app';
import { store } from './store';
import { ThemingProvider } from "theming";

const isDebug =
  window.location.host.includes("debug.stargame.one") ||
  window.location.host.includes("localhost") ||
  window.location.host.includes("127.0.0.1");

window.STARGAME_DEBUG_ = isDebug;

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <ThemingProvider>
          <App />
        </ThemingProvider>
      </Provider>
    </BrowserRouter>
  </React.StrictMode >,
  document.getElementById('root')
);

serviceWorkerRegistration.register();
